import MenuItemSingle from './MenuItemSingle'

const PagesList = ({pages, pagesOrder, type}) => {

    const list = pagesOrder.map((pageID, index) => {
        const page = pages[pageID]
        const { post_title, elementorlink } = page
       
        return (
            <li  key={index} className="item-list gap-30">
                <MenuItemSingle
                    linktext={ post_title}
                    link={elementorlink}
                />
            </li>
        )      
    })

    return (
        <div className="menu-list-container">
            <div className="menu-list">          
                <ul className="grid-container">
                    {list}
                </ul>
            </div>
        </div>
    )
}

export default PagesList